import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SeguridadService } from 'src/app/services/seguridad.service';
import { Global } from '../../../global';
import { DatePipe } from '@angular/common';
import { XlsxService } from 'src/app/services/utils/xlsx.service';

export class Lista {

    private _seguridad = new SeguridadService();
    private _prefixPage: string = 'pages';
    private _objSession = {severity: 'error', summary: 'Sesión Expirada', detail: 'Lo vamos a redirigir para volver a ingresar'};
    private _routerLogout = ['auth','logout'];
    private _items: Record<string, any>[] = [];
    // Lista de columnas a mostar
    private _columns: Record<string, any>[]
    // nombre de la tabla
    private _recordName: string;
    // nombre en singular del item
    private _name: string;
    // nombre en plural del item
    private _pluralName: string;
    // total de registros
    private _totalRecords: number = 0;
    // para la carga de regitros
    private _loading: boolean = false;
    private _navigate: string[];
    private _modulo: string;
    private _codigoRegistro: string;
    // para carga de pag y exportar
    private _cargando: boolean = false;
    private _datePipe = new DatePipe('es-PY');
    private _xlsService = new XlsxService();

    constructor( public router: Router, public messageService: MessageService, public service: any, codigoModulo?: string, codigoRegistro?: string ) {
        service.codigoModulo = codigoModulo;
        service.codigoRegistro = codigoRegistro;
        this.modulo = codigoModulo;
        this.codigoRegistro = codigoRegistro;
    }

    get currentUser() {
        return this._seguridad.getCurrentUser();
    }

    get prefixPage() {
        return this._prefixPage;
    }
    get objSession() {
        return this._objSession;
    }
    get routerLogout() {
        return this._routerLogout;
    }
    get prefix() {
        return Global.PREFIX_RECORD;
    }

    set items( items: Record<string, any>[] ) {
        this._items = items;
    }
    get items(): Record<string, any>[] {        
        return this._items;
    }

    set columns( columns: Record<string, any>[] ) {
        this._columns = columns;
    }
    get columns(): Record<string, any>[] {
        return this._columns;
    }

    set recordName( recordName: string ) {
        this._recordName = `${ Global.PREFIX_RECORD }.${ recordName }`;
    }
    get recordName() {
        return this._recordName;
    }

    set name( name: string ) {
        this._name = name;
    }
    get name(): string {
        return this._name;
    }

    set pluralName( pluralName: string ) {
        this._pluralName = pluralName;
    }
    get pluralName(): string {
        return this._pluralName;
    }

    set totalRecords( totalRecords: number ) {
        this._totalRecords = totalRecords;
    }
    get totalRecords(): number {
        return this._totalRecords;
    }

    set loading( loading: boolean ) {
        this._loading = loading;
    }
    get loading(): boolean {
        return this._loading;
    }

    set navigate( navigate: string[] ) {
        this._navigate = navigate;
    }
    get navigate() {
        return this._navigate;
    }

    set modulo( modulo: string ) {
        this._modulo = modulo;
    }
    get modulo() {
        return this._modulo;
    }

    set codigoRegistro( codigoRegistro: string ) {
        this._codigoRegistro = codigoRegistro;
    }
    get codigoRegistro(): string {
        return this._codigoRegistro;
    }

    get cargando(): boolean {
        return this._cargando;
    }

    set cargando(cargando: boolean) {
        this._cargando = cargando;
    }

    onCreate() {
        this.router.navigate([...this._navigate,'nuevo']);
    }

    onEdit( obj: Record<string, any> ) {
        this.service.obj = obj;
        this.router.navigate([...this._navigate, obj.id]);
    }

    async loadItems() {
        try {
            this._loading = true;
            const res = await this.service.getAll();
            if ( res.ok ) {
                this._items = res.resp.rows;
                this._totalRecords = res.resp.count;
            } else {
                this.messageService.add({severity: 'error', summary: res.msg, detail: res.resp});
            }
            this._loading = false;
        } catch (error: any) {
            this.messageService.add(this._objSession);
            setTimeout( () => { this.router.navigate(this._routerLogout) }, 4000);
        }
    }

    async onExport() {
        try {
            this._cargando = true;
            const resp = await this.service.getAll(Global.SIZE_GET_ALL);
            if (resp.ok && resp.resp.count > 0) {
                const datos: Record<string, any>[] = [];
                for (const item of resp.resp.rows) {
                let dato: Record<string, any> = {};
                for (const column of this.columns) {
                    if (column.hidden === false) continue;
                    if(column.type === 'date') {
                        dato[column.label] = this._datePipe.transform(item[column.field], 'dd/MM/yyyy'); 
                    
                    } else {
                        dato[column.label] = item[column.field];
                    }          
                }
                datos.push(dato);
                }
                await this._xlsService.exportAsExcelFile(datos, 'lista');
            } else {
                this.messageService.add({ severity: 'error', summary: resp.msg, detail: resp.resp });
            }
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout(() => { this.router.navigate(this.routerLogout); }, 4000);
        } finally {
            this._cargando = false;
        }
    }
}